import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tooltip tooltip--form" }
const _hoisted_2 = { class: "tooltip__cta" }
const _hoisted_3 = { class: "rte rte--small" }

import IconHelp from "@/assets/icons/icon__help.svg";

export default /*#__PURE__*/_defineComponent({
  __name: 'FormTooltip',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(IconHelp), { class: "icon icon--blue" }),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})